import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ToasterModule, ToasterService } from 'angular2-toaster';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.css']
})

export class LogoutComponent implements OnInit {

	private toasterService: ToasterService;
	public router: Router;

	constructor(private apiService: ApiService, toasterService: ToasterService) {
		this.toasterService = toasterService;
	}

	ngOnInit() {
		sessionStorage.clear();
		if (sessionStorage.getItem('access_token_nv_admin')) {
			this.apiService.logout(sessionStorage.getItem('access_token_nv_admin')).subscribe((data:any) =>{
				this.toasterService.pop('success', data.message);
				window.open("/login", "_self");
			},
			error => {
				 this.toasterService.pop('error', error.error.message);
			});
		} else {
			window.open("/login", "_self");
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts